import React, { ReactElement } from 'react';

import { Pill } from '../../../components/Pill';
import { PageProperties } from '../../../types';
import { trackEvent } from '../../../modules/analytics';
import { CUISINE_CLICKED } from '../../../constants/analytics';
import { useRouter } from 'next/router';
import { getAbsoluteUrl } from '@/helpers/formatUrl';
import { SliceLayout } from '../../../components/SliceLayout';
import { StyledHeading, RelatedSEOTags } from './CategoryLinksV2.styled';

interface CategoryLinksProps {
  pageProperties: PageProperties;
}

export function CategoryLinksV2({
  pageProperties,
}: CategoryLinksProps): ReactElement {
  const router = useRouter();

  const { locationVariable, pageContent } = pageProperties;
  const { seoVertical, relatedSeoTags } = pageContent;
  const {
    isNearMe,
    isCountry,
    isRegion,
    isCity,
    isCounty,
    name: locationName,
  } = locationVariable || {};

  //TODO: potentially simplify this logic in V3
  const venueTitle = `Browse our venue types for hire`;

  const verticalPhrase =
    seoVertical.toLowerCase() === 'catering'
      ? 'cuisines'
      : seoVertical.toLowerCase();

  let locationPhrase: string;
  if (locationName === 'near me') {
    locationPhrase = 'near you';
  } else if (locationName) {
    locationPhrase = isCity ? `near ${locationName}` : `in ${locationName}`;
  } else {
    locationPhrase = 'in the UK';
  }

  const otherTitle = `Our most popular ${verticalPhrase} ${locationPhrase}`;

  const heading =
    seoVertical.toLowerCase() === 'venues' ? venueTitle : otherTitle;

  return (
    <SliceLayout backgroundColor="white">
      <StyledHeading as="h2" style="headingExtraLarge">
        {heading}
      </StyledHeading>

      <RelatedSEOTags>
        {relatedSeoTags.map(tag => (
          <Pill
            key={tag.name}
            href={`/${tag.url}`}
            onClick={() =>
              trackEvent(CUISINE_CLICKED, {
                cuisine: tag.name,
                destinationUrl: `${getAbsoluteUrl(tag.url)}`,
                currentPage: getAbsoluteUrl(router.asPath),
              })
            }
          >
            {tag.name}

            {isNearMe && <span>&nbsp;near you&nbsp;</span>}

            {(isCountry || isRegion || isCounty || isCity) && (
              <span>&nbsp; {locationPhrase}&nbsp;</span>
            )}
          </Pill>
        ))}
      </RelatedSEOTags>
    </SliceLayout>
  );
}
